import { object, string, mixed, date } from "yup";

export const companySummaryValidation = (field) => {
  return object().shape({
    registrationName: string()
      .trim("Name cannot include leading and trailing spaces")
      .strict(true)
      .required("Name is required"),
    type: string().required("Entity type is required"),
    registrationNumber: string()
      .trim("Registration number cannot include leading and trailing spaces")
      .strict(true)
      .required("Registration number is required"),
    registrationDate: date().required("Registration date is required"),
    accountingEndMonth: string().required(
      "Accounting period end month is required"
    ),
    dateOfLastAnnualReturn: date().nullable(true),
    annualReturnDate: date().nullable(true),
    kraPin:
      field?.name === "kraPin"
        ? string()
            .trim("KRA PIN cannot include leading and trailing spaces")
            .strict(true)
            .min(11, "Must be exactly 11 characters")
            .max(11, "Must be exactly 11 characters")
            .required("KRA PIN is required")
        : string(),
    NSSFNo:
      field?.name === "NSSFNo"
        ? string().required("NSSF NO is required")
        : string(),
    NHIFNo:
      field?.name === "NHIFNo"
        ? string().required("NHIF NO is required")
        : string(),
    fileUploads: object().shape({
      kraPin:
        field?.name === "kraPin"
          ? mixed().required("KRA PIN certificate is required")
          : mixed(),
      NSSFNo:
        field?.name === "NSSFNo"
          ? mixed().required("NSSF NO certificate is required")
          : mixed(),
      NHIFNo:
        field?.name === "NHIFNo"
          ? mixed().required("NHIF NO certificate is required")
          : mixed(),
    }),
  });
};

export const getCompanyDocumentsValidation = (field) => {
  return object().shape({
    kraPin:
      field?.name === "kraPin"
        ? string()
            .trim("KRA PIN cannot include leading and trailing spaces")
            .strict(true)
            .min(11, "Must be exactly 11 characters")
            .max(11, "Must be exactly 11 characters")
            .required("KRA PIN is required")
        : string(),
    NSSFNo:
      field?.name === "NSSFNo"
        ? string().required("NSSF NO is required")
        : string(),
    NHIFNo:
      field?.name === "NHIFNo"
        ? string().required("NHIF NO is required")
        : string(),
    fileUploads: object().shape({
      kraPin:
        field?.name === "KraPin"
          ? mixed().test(
              "length",
              "KRA PIN certificate is required",
              function (value) {
                if (!value && this.options.context.kraPin) {
                  return false;
                }
                return true;
              }
            )
          : mixed(),
      NSSFNo:
        field?.name === "NSSFNo"
          ? mixed().required("NSSF NO certificate is required")
          : mixed(),
      NHIFNo:
        field?.name === "NHIFNo"
          ? mixed().required("NHIF NO certificate is required")
          : mixed(),
    }),
  });
};
